import { EcardLanding } from './EcardLanding';
export default EcardLanding;
